import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Pair } from '../models/pair.model';

export interface DailyTrend {
  date: string;
  total: number;
  googleCalls: number;
  dbCalls: number;
}

export interface SearchStats {
  totalSearches: number;
  dbHitRate: number;
  avgBarsFound: number;
  googleCalls: number;
  dbCalls: number;
  bySource: Record<string, number>;
  byQueryType: Record<string, number>;
  byCategory: Record<string, number>;
  dailyTrend: DailyTrend[];
}

@Injectable({
  providedIn: 'root'
})
export class StatisticsService {

  constructor(private apiService: ApiService) {}

  async getSearchStats(days: number = 7): Promise<SearchStats> {
    const queryParams: Pair[] = [{ key: 'days', value: days.toString() }];
    return this.apiService.doGet('stats/search', queryParams);
  }
}
